import React from 'react';
import Img from "../../images/services/ds/custom.png";
import {Container, Row, Col} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Buildpurpose(props) {
    return (
        <div className="services_orange_bg p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto text-center order-2 order-md-1">
                        <LazyLoadImage
                            src={Img}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="services_title my-auto order-1 order-md-2">
                        <h2>Leverage The Potential Of A Digital Consulting Service</h2>
                        <p>Identifying the correct course and making progress is what we aim for at TekRevol. Our
                            confidence in the digital revolution has propelled us this far and strengthened our faith in
                            technology. We offer a unique digital consulting service to leverage the power of digital
                            solutions.</p>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Buildpurpose;